import * as QueryString from 'query-string';
import { useLocation } from 'react-router-dom';

export default function useIsChangeLogMode() {
    const location = useLocation();
    const params = QueryString.parse(location.search, { arrayFormat: 'comma' });
    return params.is_change_log_mode === 'true';
}
